/**
* hero carousel banner and promotion bar slider code ( Start ).
* Initializes a slider within a given container element.
*
* @param {HTMLElement} container The parent element containing the slider.
* @param {string} nextButtonSelector CSS selector for the "next" button.
* @param {string} prevButtonSelector CSS selector for the "previous" button.
* @param {string} slidesSelector CSS selector for the slides container.
* @param {string} slideSelector CSS selector for individual slide elements.
* @param {string} pausePlaySelector CSS selector for individual slide elements.
*/
function initializeSlider(container, nextButtonSelector, prevButtonSelector, slidesSelector, slideSelector, pausePlaySelector) {
  // Check if all required elements exist
  if (container) {
    let slides = container.querySelector(slidesSelector);
    let slideElements = container.querySelectorAll(slideSelector);
    let totalSlides = slideElements.length;
    let index = 1; // Start at the first actual slide
    let slideWidth = 100;
    let autoSlideInterval;
    let isPaused = false;

    // Clone first and last slides for seamless looping
    let firstClone = slideElements[0].cloneNode(true);
    let lastClone = slideElements[totalSlides - 1].cloneNode(true);

    slides.appendChild(firstClone);
    slides.prepend(lastClone);

    // Set initial position without animation
    slides.style.transition = "none";
    slides.style.transform = `translateX(${-index * slideWidth}%)`;

    // Set initial aria-hidden attributes
    updateAriaHiddenAttributes(index, slides);

    function isValidDate(dateString) {
      const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})\s(0?[1-9]|1[0-2]):([0-5][0-9])\s([aApP][mM])$/;
    
      if (!regex.test(dateString)) return false;
    
      const [, mm, dd, yyyy, hh, min, meridian] = dateString.match(regex);
    
      // Convert to integers
      const month = parseInt(mm, 10);
      const day = parseInt(dd, 10);
      const year = parseInt(yyyy, 10);
      let hour = parseInt(hh, 10);
      const minute = parseInt(min, 10);
    
      if (meridian.toLowerCase() === "pm" && hour < 12) hour += 12;
      if (meridian.toLowerCase() === "am" && hour === 12) hour = 0;
    
      const date = new Date(year, month - 1, day, hour, minute);
    
      // Check if the date still matches the original components
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date.getHours() === hour &&
        date.getMinutes() === minute
      );
    }

    
    /**
     * timer functionality - Starts all countdowns immediately on page load
     */
    function startCountdownsForAllSlides() {
      const currentSlides = container.querySelectorAll(`${slideSelector}.original-slide`);
      currentSlides.forEach(slide => {
        const timerContainer = slide.querySelector('.promo-banner-countdown-timer-container');
        if (timerContainer) {
          startCountdownForSlideInstance(slide, timerContainer);
        }
      });
    }

    // Helper to create separate countdown for each timer
    function startCountdownForSlideInstance(slide, timerContainer) {
        const headingEl = slide.querySelector('.promo-banner-countdown-timer-heading');
        const errorEl = slide.querySelector('.timer-error-msg');
        const countdownContainer = slide.querySelector('.promo-banner-countdown-timer-container');
      
        // Show heading initially
        if (headingEl) headingEl.style.display = 'flex';
      
        const rawHtml = timerContainer.getAttribute('promo-date-end-time');
        if (!rawHtml) {
          if (errorEl) errorEl.style.display = 'flex';
          return;
        }
      
        // Extract plain text from the HTML-encoded date string
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = rawHtml;
        const dateStr = tempDiv.textContent.trim();
      
        const parsedDate = Date.parse(dateStr);
        if (!dateStr || isNaN(parsedDate)) {
          if (countdownContainer) countdownContainer.style.display = 'none';
          if (headingEl) headingEl.style.display = 'none';
          return;
        }
      
        const endTime = new Date(parsedDate).getTime();
      
        // Locate the text node inside the timer container that contains the date string
        const walker = document.createTreeWalker(timerContainer, NodeFilter.SHOW_TEXT, {
          acceptNode: node => node.nodeValue.trim().includes(dateStr) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
        });
      
        const textNode = walker.nextNode();
        if (!textNode) {
          console.warn("Countdown text node not found inside timerContainer.");
          return;
        }
        let timerInterval; // Declare this before using in updateCountdown
        // Timer update logic
        function updateCountdown() {
          const now = Date.now();
          const timeLeft = endTime - now;
      
          if (timeLeft <= 0) {
            clearInterval(timerInterval);
            if (headingEl) headingEl.style.display = 'none';
            return;
          }
      
          const hours = Math.floor(timeLeft / 3600000);
          const minutes = Math.floor((timeLeft % 3600000) / 60000);
          const seconds = Math.floor((timeLeft % 60000) / 1000);
      
          textNode.nodeValue = `${String(hours).padStart(2, '0')} h : ${String(minutes).padStart(2, '0')} m : ${String(seconds).padStart(2, '0')} s`;
        }
      
        // Kick off the countdown
        updateCountdown();
        timerInterval = setInterval(updateCountdown, 1000); // Assigned after function
      }

      if (totalSlides <= 1) {
        startCountdownsForAllSlides(); // Still start countdowns
        return;
      }
    
    /**
     * Displays the current slide with optional animation.
     *
     * @param {boolean} animated Whether to animate the transition (default: true).
     */
    function showSlide(animated = true) {
      slides.style.transition = animated ? "transform 0.9s ease-in-out" : "none";
      slides.style.transform = `translateX(${-index * slideWidth}%)`;
      updateAriaHiddenAttributes(index, slides); // Update aria-hidden attributes
    }

    /**
     * Advances to the next slide, resetting auto-slide interval.
     */
    function nextSlide() {
      index++;
      showSlide();
      // resetAutoSlide();
      if (!isPaused) {
          resetAutoSlide();
      }

      if (index >= totalSlides + 1) {
        setTimeout(() => {
          slides.style.transition = "none";
          index = 1;
          showSlide(false);
        }, 900);
      }
    }

    /**
     * Goes back to the previous slide, resetting auto-slide interval.
     */
    function prevSlide() {
      index--;
      showSlide();
      // resetAutoSlide();
      if (!isPaused) {
          resetAutoSlide();
      }

      if (index <= 0) {
        setTimeout(() => {
          slides.style.transition = "none";
          index = totalSlides;
          showSlide(false);
        }, 900);
      }
    }

    /**
     * Resets the auto-slide interval.
     */
    function resetAutoSlide() {
      clearInterval(autoSlideInterval);
      autoSlideInterval = setInterval(nextSlide, 5000);
    }

    /**
     * Toggles pause and play on slides
     * @param {String} pausePlaySelector - Dynamic selector for the button.
     */
    function togglePause(pausePlaySelector) {
      const pauseButton = container.querySelector(pausePlaySelector);
      
      isPaused = !isPaused;
      isPaused ? clearInterval(autoSlideInterval) : resetAutoSlide();
      setIcon(pauseButton, isPaused ? 'play' : 'pause', pausePlaySelector);
    }

    function setIcon(button, type, selector) {

      // 1. Safety check: Exit if the button doesn't exist on this page
      if (!button) return;

      button.classList.toggle('pause-class', type === 'pause');
      button.classList.toggle('play-class', type === 'play');
      
      // 2. Define sources with fallbacks to avoid "undefined" errors
      const tickerIcons = window.tickerBannerIcons || {};
      const heroIcons = window.heroBannerIcons || {};
      
      const iconSources = {
        '#PromoPauseButton': { 
            play: tickerIcons.tickerPlayButton, 
            pause: tickerIcons.tickerPauseButon 
        },
        '#heroBannerPauseButton': { 
            play: heroIcons.heroPlayButton, 
            pause: heroIcons.heroPauseButon 
        }
      };
      
      // 3. Safety check: Ensure the specific icon source exists for this selector
      if (!iconSources[selector] || !iconSources[selector][type]) {
        console.warn(`Icons not found for selector: ${selector}`);
        return;
      }
      
      const altIconNames = {
        '#PromoPauseButton': { play: 'ticker banner play icon', pause: 'ticker banner pause icon' },
        '#heroBannerPauseButton': { play: 'hero banner play icon', pause: 'hero banner pause icon' }
      };
      
      const ariaLabels = {
        '#PromoPauseButton': { play: 'Play Ticker Banner Slide', pause: 'Pause Ticker Banner Slide' },
        '#heroBannerPauseButton': { play: 'Play Hero Banner Slide', pause: 'Pause Hero Banner Slide' }
      };
      button.innerHTML = `<img src="${iconSources[selector][type]}" alt="${altIconNames[selector][type]}">`;
      button.setAttribute('aria-label', ariaLabels[selector][type]);
    }

    // Function to update aria-hidden attributes
    function updateAriaHiddenAttributes(currentIndex, slides) {
      const slideElements = slides.children;
      for (let i = 0; i < slideElements.length; i++) {
        if (i === currentIndex) {
          slideElements[i].setAttribute('aria-hidden', 'false');
          updateTabindex(slideElements[i], false);
        } else {
          slideElements[i].setAttribute('aria-hidden', 'true');
          updateTabindex(slideElements[i], true);
        }
      }
    }

    // Function to update tabindex attribute
    function updateTabindex(element, isActive) {
      const anchorTags = element.querySelectorAll('a');
      for (let i = 0; i < anchorTags.length; i++) {
        if (isActive) {
          anchorTags[i].setAttribute('tabindex', '-1');
        } else {
          anchorTags[i].setAttribute('tabindex', '0'); // set tabindex to -1 is not needed, instead remove attribute to prevent setting an unnecessary attribute
        }
      }
    }
    
    // Start auto-slide after a slight delay
    setTimeout(() => {
      autoSlideInterval = setInterval(nextSlide, 5000);
    }, 1000);

    // Attach event listeners to navigation buttons
    const pauseButton = container.querySelector(pausePlaySelector);
    container.querySelector(nextButtonSelector).addEventListener('click', nextSlide);
    container.querySelector(prevButtonSelector).addEventListener('click', prevSlide);
    pauseButton.addEventListener('click', () => {
      togglePause(pausePlaySelector);
    });

    // Swipe functionality
    let startX, endX;
    slides.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
    });

    slides.addEventListener('touchmove', (event) => {
      endX = event.touches[0].clientX;
    });

    slides.addEventListener('touchend', () => {
      if (startX > endX + 50) {
        nextSlide(); // Swipe left
      } else if (startX + 50 < endX) {
        prevSlide(); // Swipe right
      }
    });

    // Start countdowns for all slides immediately
    startCountdownsForAllSlides();
  }
}

// Initialize sliders on page load
document.addEventListener('DOMContentLoaded', function () {
  // Initialize hero banner carousels
  document.querySelectorAll('.hero-banner-carousel-slider').forEach(container => {
    initializeSlider(container, '.hero-banner-carousel-next', '.hero-banner-carousel-prev', '.hero-banner-carousel-slides', '.hero-banner-carousel-slide', '#heroBannerPauseButton');
  });

  // Initialize other sliders
  document.querySelectorAll('.slider-container').forEach(container => {
    initializeSlider(container, '.arrow-right', '.arrow-left', '.slides', '.slide', '#PromoPauseButton');
  });
  
});

/* * hero carousel banner and promotion bar slider code ( end ). */


/* 
* code to handle play button on video in product details section feature (start) 
*/
document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('titanBrandVideo');
  const playButton = document.getElementById('playButton');

  // Show play button initially
  playButton ? playButton.style.display = 'flex' : '';

  /**
   * Toggle play/pause state of the video and update the visibility of the play button.
   */
  function togglePlayPause() {
      if (video.paused) {
          video.play();
          hidePlayButton();
      } else {
          video.pause();
          showPlayButton();
      }
  }

  // Helper functions to manage play button visibility
  function showPlayButton() {
      // playButton.style.display = 'flex';
    playButton ? playButton.style.display = 'flex' : '';
  }
  
  function hidePlayButton() {
      // playButton.style.display = 'none';
    playButton ? playButton.style.display = 'none' : '';
  }

  // Event listeners for play/pause functionality
  [playButton, video].forEach((element) => {
      if(element){
        element.addEventListener('click', (event) => {
          event.preventDefault();
          togglePlayPause();
        });
    
        element.addEventListener('touchend', (event) => {
            event.preventDefault();
            togglePlayPause();
        });
      }
  });

  // Event listeners for video state changes
  if (video) {
      video.addEventListener('pause', showPlayButton);
      video.addEventListener('play', hidePlayButton);
      video.addEventListener('canplay', () => {
          if (video.paused) {
              showPlayButton(); // Show play button only when the video is paused and ready to play.
          }
      });
  }
});
/* * code to handle play button on video in product details section feature (start) */

// code to set underline in product description on PDP (start)
document.querySelectorAll('div#descTextBlock a').forEach(function(anchor) {
  anchor.style.textDecoration = 'underline';
  anchor.style.color = 'rgba(var(--color-foreground))';
});
// code to set underline in product description on PDP (end)

/**
  * Calculates time difference between current time and countdown end time.
  *
  * @param {number} countDownDateTime - Timestamp for the countdown in milliseconds.
  * @returns {Object|null} Time difference in hours, minutes, and seconds or null if expired.
  */
  function calculateTimeDifference(countDownDateTime) {
      const currentTime = new Date().getTime();
      const difference = countDownDateTime - currentTime;
  
      if (difference < 0) return null;
  
      const daysCalc = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hoursCalc = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesCalc = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const secondsCalc = Math.floor((difference % (1000 * 60)) / 1000);
  
      const totalHours = daysCalc * 24 + hoursCalc;
      const formattedTime = {
          hours: String(totalHours).padStart(2, "0"),
          minutes: String(minutesCalc).padStart(2, "0"),
          seconds: String(secondsCalc).padStart(2, "0")
      };
  
      return formattedTime;
  }
  
  /**
  * Updates the countdown timer in the given container.
  *
  * @param {number} countDownDateTime - Timestamp for the countdown in milliseconds.
  * @param {HTMLElement} container - Container element for the countdown timer.
  */
  function updateCountdownTimer(countDownDateTime, container) {
      const timeDiff = calculateTimeDifference(countDownDateTime);
  
      if (!timeDiff) {
          // Hide the countdown heading and display timer finished message
          document.querySelectorAll("#countdown-heading").forEach(heading => {
              heading.style.display = "none";
          });
          return;
      }

      container.querySelector("#hours").textContent = `${timeDiff.hours} h :`;
      container.querySelector("#minutes").textContent = `${timeDiff.minutes} m :`;
      container.querySelector("#seconds").textContent = `${timeDiff.seconds}s`;
  }
  
  /**
  * Starts the countdown timer for each valid sales timer.
  */
  function startCountdownTimer() {
      // Get all countdown timer containers
      document.querySelectorAll(".countdown-timer-container").forEach(container => {
          let variantElement = document.getElementById('current-variant-id');
          if (!variantElement) return;
        
          let endTime = variantElement.getAttribute('date-end-time');
          if (!endTime) return;
          
          const endTimestamp = new Date(endTime).getTime();
          if (isNaN(endTimestamp)) return;
         
          if (endTimestamp) {
            
            // Update timer every second
            const intervalId = setInterval(() => {
                updateCountdownTimer(endTimestamp, container);
                if (endTimestamp <= new Date().getTime()) {
                    clearInterval(intervalId);
                }
            }, 200);
          }
      });
  }

  function handleLabelClick() {
    setTimeout(() => {
      startCountdownTimer(); // this is delayed by 1 seconds
    }, 1000);
  }
  document.addEventListener("DOMContentLoaded", () => {
    // Call the function when the DOM is fully loaded
    startCountdownTimer();
    
    // Attach click handlers to radio labels
    document.querySelectorAll(".c-colorSwatchLabel").forEach(label => {
      label.addEventListener("click", handleLabelClick);
    });
  });

  // Removes tabindex attribute from carousel slides on page load.
  document.addEventListener('DOMContentLoaded', () => {
    const carouselWrapper = document.querySelector('.c-catCarousel__wrapper');

    if (carouselWrapper) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'tabindex') {
            mutation.target.removeAttribute('tabindex');
          }
        });
      });

      carouselWrapper.querySelectorAll('.c-catCarousel__collection').forEach(slide => {
        observer.observe(slide, { attributes: true });
        slide.removeAttribute('tabindex');
      });
    }
  });

  /**
   * Initiates button click and keydown event listeners for focusing the next image after show more button.
  */
  document.addEventListener('DOMContentLoaded', () => {
  // Store selectors in constants for better readability and maintainability
    const SHOW_MORE_BUTTON_SELECTOR = '[data-show-hidden-media-btn]';
    const SHOW_LESS_BUTTON_SELECTOR = '[data-hide-shown-media-btn]';
    const HIDDEN_MEDIA_ITEM_CLASS = '.c-product__media-item.c-hiddenMedia';

    // Query DOM elements using the selectors, but only if they exist
    const showMoreButton = document.querySelector(SHOW_MORE_BUTTON_SELECTOR);
    const showLessButton = document.querySelector(SHOW_LESS_BUTTON_SELECTOR);

    // Check if both buttons exist before proceeding
    if (showMoreButton && showLessButton) {
      /**
       * Handles show more button click event.
       */
      function handleShowMoreButtonClick() {
        const firstHiddenMediaItem = document.querySelector(HIDDEN_MEDIA_ITEM_CLASS);
        if (firstHiddenMediaItem) {

          // Get all visible media items after showing more
          const visibleMediaItems = document.querySelectorAll('.c-product__media-item:not(.c-hiddenMedia)');
      
          // Find the last default visible media item's position
          let lastDefaultVisiblePosition = -1;
          for (let i = 0; i < 6; i++) {
            if (visibleMediaItems[i]) {
              const position = parseInt(visibleMediaItems[i].dataset.position);
              if (position > lastDefaultVisiblePosition) {
                lastDefaultVisiblePosition = position;
              }
            }
          }

          // Find the next media item based on the last default visible media item's position
          let nextMediaItem;
          visibleMediaItems.forEach((mediaItem) => {
            const position = parseInt(mediaItem.dataset.position);
            if (position === lastDefaultVisiblePosition + 1) {
              nextMediaItem = mediaItem;
            }
          });

          // Move focus to the next media item
          requestAnimationFrame(() => {
            nextMediaItem.focus();
          });
        }
      }

      /**
       * Handles show less button click event.
       */
      function handleShowLessButtonClick() {
        if (showMoreButton) {
          requestAnimationFrame(() => showMoreButton.focus());
        }
      }

      /**
       * Handles keydown events for both buttons to ensure accessibility.
       * @param {KeyboardEvent} event The keyboard event that triggered this function.
       */
      function handleButtonDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          // Prevent default behavior and simulate a click on the button
          event.preventDefault();
          event.target.click();
        }
      }

      // Add event listeners to both buttons for click and keydown events, but only if they exist
      showMoreButton.addEventListener('click', handleShowMoreButtonClick);
      if (showLessButton) {
        showLessButton.addEventListener('click', handleShowLessButtonClick);
      }

      [showMoreButton, showLessButton].forEach(button => {
        if (button) {
          button.addEventListener('keydown', handleButtonDown);
        }
      });
    } else {
      console.error('Either the "show more" or "show less" button is missing.');
    }
  });

  
  // code to display button icons dynamically such as pause/play, next and prev
  document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.hero-banner-carousel-slider');

  if (!slider) return;

  const prevButton = document.getElementById('previd');
  const nextButton = document.getElementById('nextId');
  const playPauseButtons = document.querySelectorAll('#togglePlayPause');

  // Use event delegation to reduce the number of event listeners
  slider.addEventListener('click', function(e) {
    if (e.target.closest('button')) {
      const clickedBtn = e.target.closest('button').id;

      switch (clickedBtn) {
        case 'previd':
          document.querySelector('.hero-banner-carousel-prev')?.click();
          break;
        case 'nextId':
          document.querySelector('.hero-banner-carousel-next')?.click();
          break;
        case 'togglePlayPause':
          // Forward Pause/Play Click
          document.getElementById('heroBannerPauseButton')?.click();

          // Toggle state and image for ALL inner buttons to keep them in sync
          playPauseButtons.forEach(btn => {
            const img = btn.querySelector('img');
            const isPlaying = btn.getAttribute('data-state') === 'playing';

            if (isPlaying) {
              btn.setAttribute('data-state', 'paused');
              img.src = img.getAttribute('data-play-src'); // Switch to Play icon
            } else {
              btn.setAttribute('data-state', 'playing');
              img.src = img.getAttribute('data-pause-src'); // Switch to Pause icon
            }
          });
      }
    }
  });
});